var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepNums",on:{"click":_vm.gainStepData}},[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","username":"gh_3e12937b4dbc","path":_vm.path}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v("\n<style>.btn {color:#fff}</style>\n <span class=\"btn\"> 获取步数授权</span>\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }